// @ts-expect-error
import { useStyleSheetOverrides } from '@bubble-ui/provider-style-sheet-overrides';
import { useBrandVolume } from '@bubble-ui/provider-brand-volume';
import { useTheme } from '@bubble-ui/provider-theme';
import merge from './merge'; // Always override, except when brand volume isn't low and there's theming

var shouldOverrideStyleSheet = function shouldOverrideStyleSheet(brandVolume, theme) {
  return !(brandVolume !== 'low' && theme.hasTheme);
};

export default function useStyleSheet(Component, getDefaultStyleSheet, props) {
  // @ts-expect-error
  var defaultStyleSheet = getDefaultStyleSheet ? getDefaultStyleSheet(props) : {};
  var stylesheetOverrides = useStyleSheetOverrides();
  var brandVolume = useBrandVolume();
  var theme = useTheme();

  if (stylesheetOverrides) {
    var stylesheetOverride = stylesheetOverrides[Component.displayName];

    if (stylesheetOverride && shouldOverrideStyleSheet(brandVolume, theme)) {
      var customStyleSheet = stylesheetOverride(props);

      if (Object.keys(defaultStyleSheet).length > 0) {
        return merge(defaultStyleSheet, customStyleSheet);
      }

      return customStyleSheet || {};
    }
  }

  return defaultStyleSheet;
}
//# sourceMappingURL=index.js.map